import { pgTable, uuid, timestamp, varchar, index } from 'drizzle-orm/pg-core';
import { roles } from './roles';
import { dataAccessLevelEnum } from '../enums/dataAccessLevelEnum';
import { permissionVerbEnum } from '../enums/permissionVerbEnum';
import { staticResourceEnum } from '../enums/staticResourceEnum';

const schema = {
  id: uuid('id').defaultRandom().primaryKey(),
  role_id: uuid('role_id').notNull().references(() => roles.id),
  resource: staticResourceEnum('resource').notNull(), // StaticResource enum
  verb: permissionVerbEnum('verb').notNull(), // PermissionVerb enum
  data_access: dataAccessLevelEnum('data_access').notNull(), // DataAccessLevel enum
  target_role_id: uuid('target_role_id').references(() => roles.id), // Foreign key to target role for role-based access
  date_created: timestamp('date_created', { withTimezone: true, mode: 'date' }).defaultNow().notNull(),
}

/**
 * @ignore
 * @internal
 */
export const roleResourcePermissions = pgTable(
  'RoleResourcePermissions', 
  schema,
  (table) => [
    index('role_resource_permission_role_id_idx').on(table.role_id),
    index('role_resource_permission_resource_idx').on(table.resource),
    index('role_resource_permission_verb_idx').on(table.verb),
    index('role_resource_permission_data_access_idx').on(table.data_access),
    index('role_resource_permission_target_role_id_idx').on(table.target_role_id),
    index('role_resource_permission_role_resource_verb_idx').on(table.role_id, table.resource, table.verb), // Composite index for permission lookups
  ]
); 